import { z } from "zod";
import { createOAuthManager, OAuthConfig } from "./oauth.lib";

const sfctcvUserInfoSchema = z.object({
  id: z.string(),
  login: z.string(),
  email: z.string(),
  displayName: z.string(),
  membership_active: z.number().default(0),
});

const sfctcvConfig: OAuthConfig = {
  name: "SFCTCV",
  clientId: "9ei6yWN03ZLIKdB5YIXOj4xFu0QPtQQvRRAY3jlW",
  authorizeUrl: "https://www.sfctcv.org/oauth/authorize",
  renewUrl: "https://www.sfctcv.org/espace-personnel-sfctcv/",
  scope: "basic",
  storagePrefix: "sfctcv",
  canOpenRoom: (userInfo) => {
    const parsed = sfctcvUserInfoSchema.safeParse(userInfo);
    if (!parsed.success) {
      return {
        success: false,
        error: "Invalid user info",
        errorCode: "NOT_AUTHENTICATED" as const,
      };
    }
    const validUserInfo = parsed.data;

    // Token expiry is checked by the manager before this callback is invoked.
    // Membership is the only SFCTCV-specific gate.
    if (validUserInfo.membership_active !== 1) {
      return {
        success: false,
        error: "Membership inactive",
        errorCode: "MEMBERSHIP_INACTIVE" as const,
      };
    }

    return {
      success: true,
      user: validUserInfo,
    };
  },
};

export const sfctcvOAuth = createOAuthManager(sfctcvConfig);
